export default {
  headerContent: {
    title: 'Atlas Sigorta Konut (Ev) Sigortası Fiyatları',
    slogan: "Konut Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'KONUT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Atlas Mutuel Sigorta Konut Sigortası',
    description: {
      title: 'Atlas Mutuel Sigorta Konut Sigortası (Ev Sigortası) Nedir? ',
      content: [
        'Konut sigortası; konutta oluşacak yangın, hırsızlık sel ve su baskını gibi risklere karşı oluşacak güvence sağlamaktadır. Konut sigortası kişileri konutta oluşan maddi kayıplara karşı koruma altına almaktadır.',
        'Atlas Sigorta konut sigortası ile sunduğu geniş teminatları sayesinde sigortalılarına ayrıcalıklı hizmet sunmaktadır. '
      ]
    },
    subContent: {
      title: 'Atlas Sigorta Konut Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Yangın, yıldırım, infilak',
            'Sel - su baskını',
            'Fırtına',
            'Kara - hava - deniz taşıtları çarpması',
            'Dumanın vereceği zararlar',
            'Yer kayması',
            'Terör, grev, lokavt, kargaşalık, halk hareketleri, kötü niyetli hareketler',
            'Kar ağırlığı',
            'Dolu',
            'Cam kırılması',
            'Enkaz kaldırma giderleri',
            'Hırsızlık',
            'Kıymetli eşya hırsızlık',
            'Misafir eşyaları',
            'Hasar nedeniyle yapılacak ikametgah değişikliği masrafları',
            'Kira kaybı',
            'Ferdi kaza',
            'Yangın - infilak mali sorumluluk',
            'İzolasyon eksikliği teminatı',
            'Makine kırılması sigortası',
            'Elektronik cihaz sigortası',
            'Elektriksel hasarlara bağlı gıda bozulması',
            'Ev çalışanları emniyeti su istimal',
            'Kazaen kırılma teminatını içermektedir.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Konut Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Konut Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Konut Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Atlas Mutuel Sigorta Konut Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Atlas Sigorta Konut Sigortası Kapsamı Nedir? Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Konut sigortası kapsamı poliçede teminat altına alınmış risklerle orantılıdır. Sigortalı teminat altına almış olduğu tüm riskleri karşılamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Konut Sigortası Teminat Dışı Kalan Haller Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Konut sigortası teminat dışı kalan haller poliçeye ekletilmeyen teminatlar ve konut sigortası genel şartlarında belirlenmiş olan hallerdir.',
            'Konut sigortası genel şartlarına göre teminat dışı bırakılmış haller aşağıdadır.',
            'Savaş, her türlü savaş olayları, istila, yabancı düşman hareketleri, çarpışma (savaş ilan edilmiş olsun veya olmasın), iç savaş, ihtilal, isyan, ayaklanma ve bunların gerektirdiği inzibati ve askeri hareketler nedeniyle meydana gelen bütün zararlar,',
            'Herhangi bir nükleer yakıttan veya nükleer yakıtın yanması sonucu nükleer artıklardan ya da bunlara atfedilen sebeplerden meydana gelen iyonlayıcı radyasyonların veya radyo-aktivite bulaşmalarının ve bunların gerektirdiği askeri, inzibati tedbirlerin sebep olduğu bütün zararlar (Bu bentte geçen yanma deyimi kendi kendini idame ettiren herhangi bir nükleer ayrışım olayını da kapsayacaktır.),',
            'Kamu otoritesi tarafından sigortalı varlıklar üzerinde yapılacak tasarruflar sebebiyle meydana gelen bütün zararlar,',
            'Yangın olmaksızın, sigortalı varlıkların kendi kusurlarından veya kendi bünyelerinde meydana gelen bozulmalar nedeniyle uğradıkları zararlar,',
            'Yangın olmaksızın sigortalı varlıkların işlenmek üzere veya başka bir nedenle ateşe, sıcaklığa tutulmasından, ateş bulunan benzeri bir yere düşmesinden, atılmasından, elbise, çamaşır ve diğer eşya yanıklığı gibi alev almaksızın kavrulmasından, yanmasından kaynaklanan veya ısıtma, aydınlatma, ütüleme aletleri ile lamba, mum, sigara ve bunların benzerlerine temasından doğan zararlar,',
            'Yangın olmaksızın, elektrikle çalışan her türlü motor, elektrikli veya elektronik alet, cihaz, tesisat ve kordonlarının kısa devre, topraklama, voltaj iniş çıkışları ile bu yüzden ısınma ve endüksiyon cereyanı gibi nedenlerle uğrayacakları zararlar,',
            'Alçak basınç sebebiyle kapların içeri doğru çökmesi, yırtılması, benzeri şekilde deformasyonu, yıpranması, santrifüj kuvvetler ve mekanik olaylar nedeniyle sigortalı cihaz ya da motorlarda meydana gelen bütün zararlar.'
          ]
        }
      ]
    },
    {
      title: 'Atlas Sigorta Konut (Ev) Sigortası Ne Zaman Başlar?',
      content: [
        {
          paragraph:
            'Konut sigortası poliçenin ödemesi yapıldığı zaman başlamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Konut Sigortası İçin Gerekli Bilgiler Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Kimlik bilgileri,',
            'Konutun açık adresi,',
            'Bulunduğu kat,',
            'Brüt metrekare,',
            'İnşa bedeli,',
            'Eşya bedeli gibi belge ve bilgilerdir.'
          ]
        }
      ]
    },
    {
      title: 'Atlas Sigorta Konut Sigortası Dask Yerine Geçer Mi?',
      content: [
        {
          paragraph: 'Konut sigortası deprem sigortası yerine geçmemektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Konut Sigortası Ne İşe Yarar?',
      content: [
        {
          paragraph:
            'Konut sigortası evinizi ve eşyalarınızı oluşabilecek hasarlardan koruyarak sizi maddi kayıplardan kurtarır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Konut Sigortası Hasarsızlık İndirimi Nedir?',
      content: [
        {
          paragraph:
            'Hasarsızlık indirimi sigorta başlangıç tarihinden bitiş tarihleri arasında hasar oluşmaması sonucunda sigortalıya verilen bir ek indirimdir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Konut Sigortası Geçerlilik Süresi Ne Kadar?',
      content: [
        {
          paragraph: 'Konut sigortası geçerlilik süresi 1 yıldır.',
          subList: null
        }
      ]
    },
    {
      title: 'Neden Atlas Sigorta Konut Sigortası Yaptırmalıyım?',
      content: [
        {
          paragraph:
            'Konut sigortası konutu ve eşyaları oluşabilecek maddi risklere karşı korumaktadır. Konut sigortası olmaması risklerin oluşması sonucunda büyük çaplı maddi kayıplara yol açar. Atlas Sigorta ile bu riskleri önleyebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Konut Sigortası Yaptırmak Zorunlu Mu?',
      content: [
        {
          paragraph:
            'Konut sigortası isteğe bağlı bir sigorta ürünüdür. Yaptırılması zorunlu değildir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Konut Sigortası Hizmetleri Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Avantajlı Diş Sağlığı Paketi',
            'Su Tesisatı Hizmeti',
            'Elektrik Tesisatı Hizmeti',
            'Mobilya Mini Hasar Onarımı',
            'Sert Zemin Onarım Hizmeti',
            'Döşeme ve Halı Onarım Hizmeti',
            'Leke Çıkarma Hizmeti'
          ]
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Konut Sigortası Mobilya Mini Hasarlarını Kapsar Mı?',
      content: [
        {
          paragraph:
            'Poliçe vadesi boyunca oluşan küçük çaplı mobilya hasarlarınız poliçe kapsamındadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Konut Sigortası Kira Kaybı Nedir?',
      content: [
        {
          paragraph:
            'Kira kaybı, konuttu her hangi bir riskten kaynaklı hasar oluşması sonucunda evin kullanamaz halde gelmesi durumunda oluşacak kira kaybını karşılamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Konut Sigortası Rutubet Hasarını Karşılar Mı?',
      content: [
        {
          paragraph:
            'İzolasyon eksikliğine bağlı olarak oluşan rutubet hasarları poliçe kapsamı dahilindedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Konut Sigortası Kiracı Tarafından Yaptırılabilir Mi?',
      content: [
        {
          paragraph:
            'Kiracı tarafından içerisinde bulunan, eşyalarını güvence altına almak için konut sigortası yaptırabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Konut Sigortası Hasar Ödemesi Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Tazminat ödemesi tazminat miktarının belirlenmesinin ardından sigorta şirketi tarafından poliçede yazan bedeli aşmamak kaydıyla hak sahibine yapılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Konut Sigortası Hesaplama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Konut sigortası hesaplaması, konut ve sigortalı bilgileri girilerek hesaplanmaktadır. Girilen bu bilgiler doğru ve kesin olmalıdır. Aksi halde sigorta eksik ya da aşkın olabilmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Konut Sigortası Nerede Yapılır?',
      content: [
        {
          paragraph:
            'Konut sigortası, konut sigortası düzenlemeye yetkilendirilmiş kişi veya kurumlardan yapılmaktadır. ',
          subList: null
        },
        {
          paragraph:
            '<strong>Alokasko.com</strong> olarak uzman hasar ve sigorta danışmanlarımızla konutunuzu güvence altına almaktayız.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Konut Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'Konut sigortası fiyatları sigortalanacak konutun bedeli, eşya bedelleri ve aylık olarak değişmektedir. Bu bağlamda net bir konut sigortası fiyatı olmamaktadır. Gerekli bilgilerin girilmesi ile alacağınız teklif sonucunda fiyatları öğrenebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Online Konut Sigortası Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Konut sigortasını online olarak almanız mümkündür. Bunun için tek yapmanız gereken alokasko.com üzerinden başvuru formunda yer alan bilgileri doldurmaktır.',
          subList: null
        },
        {
          paragraph:
            'Bilgilerin uzman danışmanlarımıza iletilmesi sonucu sizin için en uygun teklif çalışılarak tarafınıza sunulmaktadır. Size sunulan teklifi değerlendirebilir, konut sigortası hakkında detaylı bilgi alabilir ve poliçe tanziminde bulunabilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
